import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { MatchOfferInfo } from './MatchOfferInfo.js';
import Html5Entities from '../../external/npm/html5-entities.js';
import { projectFormatter } from './projectFormatter.js';


/* global formatMediumDate */

export let FundedProjectCard = ({ project, showClassroomPhoto }) => {
    function makeTyMessage() {
        const tyAssets = project.thankYouAssets;
        let thankYouMessage = tyAssets && (tyAssets.resultsLetter || tyAssets.interimThankYou);

        if (!thankYouMessage) {
            return null;
        }

        thankYouMessage = thankYouMessage.slice(0, thankYouMessage.search(/[\n\r]*With gratitude/))
            .replace(/[\n\r]+/g, '</p><p>');

        return (
            <div className="funded-message">
                <p dangerouslySetInnerHTML={{ __html: thankYouMessage + '&rdquo;' }}></p>
                <p className="teacher-signature">With gratitude,</p>
                <p className="teacher-signature">{Html5Entities.decode(project.teacherName)}</p>
            </div>
        );
    }

    function getClassroomPhoto() {
        if (showClassroomPhoto) {
            return (
                <div className="photo-content">
                    <div className="classroom-photo" style={{ backgroundImage: 'url(' + project.imageURL + ')' }}></div>
                </div>
            );
        }
    }

    var proposalURL = projectFormatter.removeUTMParams(project.proposalURL);
    var fundedClassName = project.completedMatching ? 'funded-project with-match' : 'funded-project';

    return (
        <li className={fundedClassName}>
            {getClassroomPhoto()}
            <div className="main-content">
                <h2>
                    {/* WS-34556: Temporarily unlink CE projects */}
                    {project.essentialsListShipment ?
                        <div style={{color:'#000'}}>{project.title}</div> :
                        <a href={proposalURL} dangerouslySetInnerHTML={{ __html: project.title }}></a>
                    }
                </h2>
                <span className="date-funded">Funded {formatMediumDate(project.fullyFundedDate)}</span>
                {makeTyMessage()}
            </div>
            <MatchOfferInfo
                project={project}
                fullyFunded={true}
                numDonors={project.numDonors}
            />
        </li>
    );
};

FundedProjectCard.propTypes = {
    project: PropTypes.arrayOf(PropTypes.object).isRequired,
    showClassroomPhoto: PropTypes.bool,
};

FundedProjectCard.defaultProps = {
    showClassroomPhoto: false,
};

FundedProjectCard = memo(FundedProjectCard);
